import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Image from "../../../image/image";
import ErrorBoundary from "../../../../error-boundary";
import { LinkPropType } from "../../../link/link";
import LazyLoad from "react-lazyload";
import Marquee from "react-fast-marquee";
import useAccessibilityContext from "@default/js/accessibility/store/use-accessibility-context";

const Logos = ({ logos, noTabbing, id }) => {
  const { simpleDesign } = useAccessibilityContext();

  return (
    <>
      {logos.map((item, subIndex) => (
        <div
          key={subIndex + id}
          className={classNames({
            partner: true,
            "col-6 col-lg-3": simpleDesign,
          })}
          data-no-tabbing={noTabbing}
          tabIndex={noTabbing ? -1 : undefined}
          aria-hidden={noTabbing}
        >
          {item.fieldLink !== null ? (
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={item.fieldLink?.uri?.path}
              aria-label={`Sponsor: ${item.fieldLink?.uri?.path}`}
              tabIndex={noTabbing ? -1 : 0}
            >
              <LazyLoad offset={500}>
                <Image data={item.fieldMediaImage} />
              </LazyLoad>
            </a>
          ) : (
            <ErrorBoundary>
              <LazyLoad offset={500}>
                <Image data={item.fieldMediaImage} />
              </LazyLoad>
            </ErrorBoundary>
          )}
        </div>
      ))}
    </>
  );
};

Logos.propTypes = {
  logos: PropTypes.arrayOf(
    PropTypes.shape({
      fieldLink: LinkPropType,
      fieldMediaImage: PropTypes.shape({
        style: PropTypes.shape({
          url: PropTypes.string,
        }).isRequired,
        styleFullPage: null,
        desktop: null,
        mobile: null,
      }),
    })
  ).isRequired,
  noTabbing: PropTypes.bool,
};

const ParagraphLogosPartners = ({ content }) => {
  const [speed, setSpeed] = useState(40 + Math.floor(Math.random() * 20));
  const [isFocused, setIsFocused] = useState(false);
  const { simpleDesign } = useAccessibilityContext();

  const sectionClassNames = classNames({
    "paragraph paragraph-logos-partners": true,
    small: content.fieldSmall,
  });

  return (
    <section
      className={sectionClassNames}
      data-darkmode={content.fieldDarkMode}
    >
      {content.fieldHeading && (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="heading body-m">{content.fieldHeading}</div>
            </div>
          </div>
        </div>
      )}

      {simpleDesign ? (
        <div className="container">
          <div className="row">
            <Logos logos={content.fieldLogosPartners} />
          </div>
        </div>
      ) : (
        <article
          className="marquee-wrapper"
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          aria-label={content.fieldHeading}
        >
          <div className="sr-only">
            <Logos logos={content.fieldLogosPartners} id={content.id} />
          </div>
          <Marquee
            pauseOnHover={true}
            pauseOnClick={false}
            play={!isFocused}
            speed={speed}
            gradient={false}
          >
            {[...Array(8)].map((_, index) => (
              <div key={index} className="marquee-element">
                <Logos
                  logos={content.fieldLogosPartners}
                  id={content.id}
                  noTabbing
                />
              </div>
            ))}
          </Marquee>
        </article>
      )}
    </section>
  );
};

ParagraphLogosPartners.propTypes = {
  viewMode: PropTypes.string,
  content: PropTypes.shape({
    fieldHeading: PropTypes.string.isRequired,
    fieldLogosPartners: PropTypes.arrayOf(
      PropTypes.shape({
        fieldLink: LinkPropType,
        fieldMediaImage: PropTypes.shape({
          style: PropTypes.shape({
            url: PropTypes.string,
          }).isRequired,
          styleFullPage: null,
          desktop: null,
          mobile: null,
        }),
      })
    ),
  }),
};

export default ParagraphLogosPartners;
